<template>
	<div class="container container--narrow pdt-50 mgb-50">
		<div v-if="groupQuestionCount === 1">
			<question-tag
				:avgSolveTime="question.avgSolveTime"
				:correctRate="question.avgSolveTime"
				:level="paperLevel"
			></question-tag>
							<div v-for="(node, n) in nodes" :key="n">
									<answer-type v-if="n % 2"
										:data="question.blank.items[node]"
										:itemIndex="node"
										:setedAnswer="setedAnswer.texts[node]"
										@setAnswer="setAnswer"
									></answer-type>
									<div v-else class="mgt-24 t-subtitle6 t-line-h-28 font-rn">{{node}}</div>
							</div>
							<div v-if="question && question.contents && question.contents.image" class="mgt-16">
								<img :src="question.contents.image" alt="" class="b-radius4">
							</div>
				</div>
				<div v-else>
					<div v-if="index === 0" class="mgt-16 t-body1 t-line-h-28">
						{{groupQuestionTitle}}
					</div>
					<div class="mgt-24">
						<div class="mdc-card pda-24 bg-documentGray position-relative">
							<question-tag
								class="mgb-16"
								:avgSolveTime="question.avgSolveTime"
								:correctRate="question.avgSolveTime"
								:level="paperLevel"
							></question-tag>
							<div v-for="(node, n) in nodes" :key="n">
								<answer-type v-if="n % 2"
									:data="question.blank.items[node]"
									:itemIndex="node"
									:setedAnswer="setedAnswer.texts[node]"
									@setAnswer="setAnswer"
								></answer-type>
								<div v-else class="mgt-16 t-subtitle6 t-line-h-28 font-rn">{{node}}</div>
							</div>
							<div v-if="question && question.contents && question.contents.image" class="mgt-16">
								<img :src="question.contents.image" alt="" class="b-radius4">
							</div>
						</div>
					</div>
				</div>
				<question-tip v-if="question.tip" :marginType="groupQuestionCount === 1 ? true :false" :tip="question.tip" />
	</div>
</template>

<script>
/**
 * 응답내장형 문항 컴포넌트(fill in the blank type question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import {questionMixin} from '@/mixins/question.js'
import AnswerType from './AnswerType.vue'

export default {
	props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'currentQuestionCheckStatus', 'setedAnswer', 'paperLevel', 'index'],
	data() {
		return {
			texts: '',
			isSolve: false,
			parsedQuestionTitle: ''
		}
	},
	components: {
		'question-tag': QuestionTag,
		'question-tip': QuestionTip,
		'answer-type': AnswerType
	},

	mixins: [questionMixin],

	mounted() {
		this.texts = this.setedAnswer.texts
		this.isSolve = this.setedAnswer.isSolve
		this.solveTime = this.setedAnswer.solveTime || 0
		this.startTimer()
		this.parsedQuestionTitle = this.question.blank.contents
	},

	watch: {
		// currentQuestionCheckStatus에 따라 타이머 동작(currentQuestionCheckStatus timer action)
		currentQuestionCheckStatus: function(value) {
			if (!value) {
				this.startTimer()
			} else {
				this.clearTimer()
			}
		}
	},

	computed: {
		// 응답 내장형 문항 파싱(parse question)
		nodes() {
			return this.parsedQuestionTitle.split(/\{([0-9]+)\}/g)
		}
	},

	methods: {
		//답안정보 설정 및 부모 컴포넌트에 전달(Answer information setting and delivery to parent component)
		setAnswer(data) {
			this.texts[data.index] = data.text

			let answerCount = 0
			_.each(this.texts, (text) => {
				if (text) {
					answerCount++
				}
			})

			if (answerCount === this.question.blank.items.length) {
				this.isSolve = true
			} else {
				this.isSolve = false
			}
			this.currentQuestionCheckTrueFalse()
      this.checkIsChecked()
		},

		currentQuestionCheckTrueFalse() {
      this.$emit('checkCurrentQuestionStatus')
    },

    checkIsChecked() {
      let params = this.setParam();
      this.$emit('checkIsCheckeds', params);
      const debouncedSetAnswers = _.debounce(() => {
        this.$emit('setAnswers', params);
      }, 500);
      debouncedSetAnswers();
    },

		// 파라미터 설정(set parameter)
		setParam() {
			let params = {
				questionId: this.question.id,
				text: '',
				selected: [],
				texts: this.texts,
				startDate: this.startDate,
				solveTime: this.solveTime,
				isSolve: this.isSolve,
				groupId: this.question.groupId,
			}
			return params
		},
	}
}
</script>
